module.exports = __webpack_public_path__ + "img/sp2.ed6b48c4.svg";